import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const serviceOptions = [
  { label: "Man & Van Rubbish Removal Service", slug: "rubbish-clearance" },
  { label: "Sofa Removal", slug: "sofa-removal" },
  { label: "House Clearance", slug: "house-clearance" },
  { label: "Appliance Removal", slug: "appliance-removal" },
  { label: "Furniture Removal", slug: "furniture-removal" },
  { label: "Private Bin Collection", slug: "private-bin-collection" },
];

export default function QuoteModal({ isOpen, onClose }: QuoteModalProps) {
  const navigate = useNavigate();
  const [selectedSlug, setSelectedSlug] = useState("");
  const [postcode, setPostcode] = useState("");

  if (!isOpen) return null;

  const handleBook = (e: React.FormEvent) => {
    e.preventDefault();
    onClose();
    const params = new URLSearchParams();
    if (selectedSlug) params.set("service", selectedSlug);
    if (postcode.trim()) params.set("postcode", postcode.trim().toUpperCase());
    navigate(`/book?${params.toString()}`);
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-0 sm:p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-t-3xl sm:rounded-3xl w-full max-w-md shadow-2xl overflow-hidden thick-border cartoon-shadow max-h-[92vh] flex flex-col">
        {/* Header */}
        <div className="bg-cl-dark px-8 py-6 flex items-center justify-between">
          <div>
            <h3 className="font-black text-white text-xl">Book Now</h3>
            <p className="text-white/60 text-sm font-semibold">Fixed prices · No hidden extras</p>
          </div>
          <button
            onClick={onClose}
            style={{ touchAction: "manipulation" }}
            className="w-11 h-11 flex items-center justify-center bg-white/10 active:bg-white/20 rounded-full text-white cursor-pointer transition-colors flex-shrink-0"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="px-6 py-6 overflow-y-auto">
          <form onSubmit={handleBook} className="flex flex-col gap-4">
            <div>
              <label className="block text-sm font-black text-cl-dark mb-2">
                What do you need removing?
              </label>
              <div className="grid grid-cols-1 gap-2">
                {serviceOptions.map((s) => (
                  <button
                    key={s.slug}
                    type="button"
                    onClick={() => setSelectedSlug(s.slug)}
                    style={{ touchAction: "manipulation" }}
                    className={`w-full text-left px-4 py-3.5 rounded-xl border-2 text-sm font-bold transition-all cursor-pointer active:scale-[0.98] ${
                      selectedSlug === s.slug
                        ? "border-cl-green bg-cl-lime text-cl-dark"
                        : "border-gray-200 bg-white text-cl-dark hover:border-cl-green"
                    }`}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-black text-cl-dark mb-2">
                Your postcode
              </label>
              <input
                type="text"
                placeholder="e.g. WR9 0BX"
                value={postcode}
                onChange={(e) => setPostcode(e.target.value)}
                className="w-full border-2 border-gray-200 focus:border-cl-green rounded-xl px-4 py-3.5 text-sm font-semibold text-cl-dark bg-white outline-none transition-colors"
              />
            </div>

            <button
              type="submit"
              disabled={!selectedSlug}
              style={{ touchAction: "manipulation" }}
              className="w-full bg-cl-green disabled:opacity-40 disabled:cursor-not-allowed text-white font-black py-4 rounded-2xl text-base transition-all cartoon-btn-green"
            >
              Get Instant Price →
            </button>
            <p className="text-gray-400 text-xs text-center font-semibold">
              No card required · 60-second booking
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}